import {
  type Indicator,
} from "../../lib/types";


export function downloadBlob(
  data: BlobPart | Uint8Array<ArrayBufferLike>,
  name: string,
  type: string,
) {
  let part: BlobPart;
  if (data instanceof Uint8Array) {
    const copy = new Uint8Array(new ArrayBuffer(data.byteLength));
    copy.set(data);
    part = copy;
  } else {
    part = data;
  }
  const url = URL.createObjectURL(new Blob([part], { type }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = name;
  anchor.rel = "noopener";
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}


export function maskSecret(indicator: Indicator, reveal: boolean) {
  if (
    reveal ||
    !["webhook", "telegram"].includes(indicator.type) ||
    indicator.value.length < 16
  ) {
    return indicator.value;
  }
  return `${indicator.value.slice(0, 12)}${"•".repeat(12)}${indicator.value.slice(-6)}`;
}
